import React, {Component} from 'react';
import FooterLogo from "../../../static/assets/img/logo-white.png";
import DownloadAppleImg from "../../../static/assets/img/App-store.png";
import { withTranslation } from 'react-i18next';

class Footer extends Component {

    render() {
        const {t} = this.props;
        return (
            <footer className="footer">
                <div className="footerTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="footerSingleItem footerTopLeft">
                                    <a href="#" className="footerLogo">
                                        <img src={FooterLogo} alt="img"/>
                                    </a>
                                    <p className="footerPara">
                                        <span className="icon">
                                            <i className="fas fa-phone-alt"></i>
                                        </span>
                                        <span className="text">{t('footer.phone')}</span>
                                    </p>
                                    <p className="footerPara">
                                        <span className="icon">
                                            <i className="fas fa-envelope"></i>
                                        </span>
                                        <span className="text">liveradio@gmail.com</span>
                                    </p>
                                    <p className="footerPara">
                                        <span className="icon">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </span>
                                        <span className="text">{t('footer.address')}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="footerSingleItem pl50">
                                    <h3 className="footerTitle">{t('footer.links')}</h3>
                                    <ul className="footerMenu">
                                        <li><a href="#">{t('footer.terms')}</a></li>
                                        <li><a href="#">{t('footer.privacy')}</a></li>
                                        <li><a href="#">{t('footer.feedback')}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="footerSingleItem">
                                    <h3 className="footerTitle">{t('footer.dloadApp')}</h3>
                                    <p className="footerPara">{t('footer.allType')}</p>
                                    <div className="downLoadApp"><a href="#"><img src={DownloadAppleImg} alt="img"/></a></div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                <div className="footerSingleItem">
                                    <h3 className="footerTitle">{t('footer.newsletter')}</h3>
                                    <p className="footerPara">{t('footer.latest')}</p>
                                    <div className="footerNewsletterForm">
                                        <form action="#">
                                            <div className="form-group">
                                                <input type="email" className="form-control" placeholder={t('footer.email')} />
                                                <button className="btn btnSub">{t('footer.subscribe')}</button>
                                                <i className="far fa-envelope"></i>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footerBottom">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-6 col-12">
                                <p className="footerCopy">&copy; {t('footer.year')} <a href="#">{t('footer.liveTech')}</a> {t('footer.allrights')}</p>
                            </div>
                            <div className="col-sm-6 col-12">
                                <ul className="footerSocial">
                                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                                    <li><a href="#"><i className="fab fa-youtube"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default withTranslation()(Footer);